import { render, staticRenderFns } from "./forgetpassword.vue?vue&type=template&id=dac67bbc&scoped=true&"
import script from "./forgetpassword.vue?vue&type=script&lang=js&"
export * from "./forgetpassword.vue?vue&type=script&lang=js&"
import style0 from "./forgetpassword.vue?vue&type=style&index=0&id=dac67bbc&scoped=true&lang=css&"
import style1 from "./forgetpassword.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac67bbc",
  null
  
)

export default component.exports